import React, { useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Auth from './util/Auth';
import MobileDrawer from './components/drawer/MobileDrawer';
import Login from './views/login/Login';
import MobileLandsTable from './components/MobileLandsTable';
import PERMISSIONS_LIST from './util/RolesEnum';
import RoleProtectedRoute from './components/router/middleware/RoleProtectedRoute';

const PWARoutes = (props) => {
    const [State, setState] = useState({
        User: {
            isLoggedIn: Auth.isAuthenticated(),
            roles: Auth.getRoles(),
        },
    });

    const withMobileDrawer = (Component) => (props) => {
        return (
            <MobileDrawer>
                <Component {...props} />
            </MobileDrawer>
        );
    };

    const handleLogin = (newState) => {
        setState(newState);
        // Force re-check of auth state after login
        setTimeout(() => {
            setState({
                User: {
                    isLoggedIn: Auth.isAuthenticated(),
                    roles: Auth.getRoles(),
                },
            });
        }, 100);
    };

    if (!State.User.isLoggedIn) {
        return (
            <BrowserRouter>
                <Switch>
                    <Route
                        path="/login"
                        render={(routeProps) => (
                            <Login {...routeProps} loginFn={handleLogin} />
                        )}
                    />
                    <Route
                        path="/"
                        exact
                        render={(routeProps) => (
                            <Login {...routeProps} loginFn={handleLogin} />
                        )}
                    />
                    <Redirect to="/login" />
                </Switch>
            </BrowserRouter>
        );
    }

    return (
        <BrowserRouter>
            <Switch>
                {/* Default route - redirect to lands after login */}
                <Route path="/" exact>
                    <Redirect to="/lands" />
                </Route>

                {/* Lands table - mobile styled PWA page */}
                <RoleProtectedRoute
                    exact
                    path="/lands"
                    component={withMobileDrawer(MobileLandsTable)}
                    requiredRoles={[PERMISSIONS_LIST.READ.READ_LANDS]}
                />
                {/* Additional routes can be added here */}

                {/* Catch all other routes and redirect back to lands table */}
                <Route path="*">
                    <Redirect to="/lands" />
                </Route>
            </Switch>
        </BrowserRouter>
    );
};

export default PWARoutes;